import { useApiCall } from "@jane/lib/src/api";
import { Checkbox } from "@jane/lib/src/components/form/Checkbox";
import { Input } from "@jane/lib/src/components/form/Input";
import {FC, useState} from "react";
import {config} from "../config";
import {Autocomplete} from "../../../lib/src/components/form/auto-complete/Autocomplete";
import {CertificateEnum} from "../pages/learn/CertificateEnum";
import {LearnCategory} from "../../../lib/src/api/repositories/learn-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const AddLearnModuleModal: FC<{parentCategory: LearnCategory|null, onFinished: () => void}> = (props) => {
  const {learn} = useApiCall(config)
  const [name, setName] = useState('')
  const [type, setType] = useState('')
  const [description, setDescription] = useState('')
  const [mandatory, setMandatory] = useState(false)

  console.log(props.parentCategory)
  const save = async () => {
    await learn.addModule(
      name,
      description,
      mandatory,
      type,
      props.parentCategory?.id ?? null
    )
    props.onFinished()
  }

  const certificateTypes: { [key: string]: string } = Object.fromEntries(
    Object.entries(CertificateEnum)
  );

  return <div className={"flex flex-col space-y-3"}>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <Autocomplete label={'Certificaat type'} options={certificateTypes} value={type} onChange={(ct) => setType(ct)}/>
    <Input type={'textarea'} label={'Omschrijving'} value={description} onChange={setDescription} />
    <Checkbox label={'Verplicht onderwerp'} description={'Medewerkers zien dit onderdeel in hun app overzicht zolang ze het nog niet hebben afgerond.'} checked={mandatory} onChange={setMandatory} />
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}